import React from 'react';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  name: 'María Fernanda López',
  age: 34,
  role: 'docente de secundaria',
  city: 'Córdoba',
  text: 'Me salvó la vida. Siempre perdía los domingos buscando qué hacer para las fechas patrias. Ahora abro el pack, elijo la actividad y listo. Ahorré muchísimo tiempo y las clases salen hermosas.'
}, {
  name: 'Carolina Ruiz',
  age: 41,
  role: 'docente de secundaria',
  city: 'Rosario',
  text: 'Lo que más valoro es tener todo el material organizado en un solo lugar. Las explicaciones son súper claras para los chicos y las actividades son diferentes a lo que se encuentra siempre en internet.'
}, {
  name: 'Luciana Gómez',
  age: 29,
  role: 'docente de secundaria',
  city: 'Buenos Aires',
  text: 'Soy docente nueva y me daba mucho miedo el tema de los actos y las efemérides. Este pack me dio una seguridad increíble. Los discursos de los bonos son preciosos, me felicitaron en el último acto.'
}];
export function TestimonialsSection() {
  return <section className="py-6 px-4 bg-gray-50" data-id="element-352">
      <div className="max-w-6xl mx-auto" data-id="element-353">
        <h2 className="text-[20px] font-black mb-5 text-center text-[#5B3FA0]" data-id="element-354">
          Lo que dicen otras docentes
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-355">
          {testimonials.map((t, index) => <div key={index} className="bg-white p-4 rounded-2xl shadow-md border border-gray-100 flex flex-col" data-id="element-356">
              <div className="flex mb-2" data-id="element-357">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-358" />)}
              </div>
              <p className="text-gray-700 italic mb-3 flex-grow" data-id="element-359">"{t.text}"</p>
              <div className="border-t pt-3 mt-auto" data-id="element-360">
                <p className="font-bold text-gray-900" data-id="element-361">
                  {t.name}, {t.age} años
                </p>
                <p className="text-sm text-gray-500" data-id="element-362">{t.role}</p>
                <p className="text-sm text-gray-500" data-id="element-363">{t.city}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}